import { create } from 'zustand'
import type { ApiError } from '@/shared/api'
import type { Viewer } from './types'

type ViewerState = {
  /** `null`, пока `/app/me` не ответил. */
  viewer: Viewer | null
  /**
   * Бэкенд не принял подпись Telegram (`TG-*`) или пользователь заблокирован
   * (`U-003`) — на любом запросе, не только на `/app/me`. Подпись одна на всё
   * приложение, поэтому и отказ общий: оболочка показывает вместо экранов
   * «Откройте заново», «Аккаунт заблокирован» или ошибку приложения.
   */
  authError: ApiError | null
  setViewer: (viewer: Viewer) => void
  setAuthError: (error: ApiError) => void
  clearAuthError: () => void
}

/**
 * Профиль — в Zustand, а не только в кэше запросов: его читают синхронно
 * экраны и обработчики. Не персистится: источник правды — бэкенд, а подпись
 * при каждом запуске новая.
 */
export const useViewerStore = create<ViewerState>()((set) => ({
  viewer: null,
  authError: null,
  setViewer: (viewer) => set({ viewer }),
  setAuthError: (authError) => set({ authError }),
  clearAuthError: () => set({ authError: null }),
}))
